import { Box } from "@mui/system";
import { Route, Routes, BrowserRouter, useNavigate } from "react-router-dom";
import EggFreezeCalculatorForm from "./FormContainer";
import { EggFreezeCalculatorReport } from "..";
import { ReportProvider } from "../../contexts/ReportContext";
import withAuthentication from "../../hocs/withAuthentication";
import { useApp } from "../../contexts/AppContext";
import { useEffect, useMemo } from "react";
import { ResourceProvider } from "../../contexts/ResourceContext";

const Page: React.FC = () => {
  const navigate = useNavigate();
  const { updateBreadcrumbs } = useApp();
  const { translate } = useApp();
  const translations = useMemo(() => translate("eggfreeze"), [translate]);
  useEffect(() => {
    updateBreadcrumbs([
      {
        label: translations.report.breadcrumbs.eggFreezeCalculator,
        onClick: () => {
          navigate("/calc");
        },
      },
    ]);
  }, []);

  return (
    <ResourceProvider>
      <Box marginBottom={8}>
        <Routes>
          <Route element={<EggFreezeCalculatorForm />} path="/" />
          <Route
            element={
              <ReportProvider>
                <EggFreezeCalculatorReport />
              </ReportProvider>
            }
            path="/report"
          />
        </Routes>
      </Box>
    </ResourceProvider>
  );
};

export default withAuthentication(Page);
